import { LAxios } from "../axios";
import { catchHandler } from "../catch-handler";
import { SignInInput, AuthOutput } from "./type";

export const signIn = async (
  data?: SignInInput,
): Promise<AuthOutput | string | undefined> => {
  try {
    const response = await LAxios.post("auth/sign-in", {
      password: data?.password,
      email: data?.email,
    });
    return response.data;
  } catch (error) {
    return catchHandler<AuthOutput>(error, data, signIn, {});
  }
};

export const refreshToken = async (): Promise<AuthOutput | undefined> => {
  try {
    const token = sessionStorage.getItem(
      process.env.REACT_APP_REFRESH_TOKEN as string,
    );
    const response = await LAxios.post("auth/refresh-token", undefined, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {}
};
